import { render, staticRenderFns } from "./ConventionSectionsTableCell.vue?vue&type=template&id=f805ab58&scoped=true"
import script from "./ConventionSectionsTableCell.vue?vue&type=script&lang=js"
export * from "./ConventionSectionsTableCell.vue?vue&type=script&lang=js"
import style0 from "./ConventionSectionsTableCell.vue?vue&type=style&index=0&id=f805ab58&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f805ab58",
  null
  
)

export default component.exports